import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  assignMasterScheduleAllocations,
  copyMasterSchedule,
  deleteSelectedMasterScheduleAllocations,
  getMasterScheduleAllocation,
  getMasterScheduleCalendar,
  getMasterScheduleLegends,
  getMasterScheduleReferenceData,
  listAvailableCrew,
  ListAvailableCrew$Params,
  replaceMasterScheduleAllocations,
} from '../../../api/scheduler/functions';
import { AssignMasterScheduleAllocationRequest } from '../../../api/scheduler/models/assign-master-schedule-allocation-request';
import { BaseResponse } from '../../../api/scheduler/models/base-response';
import { AvailableCrewResponse } from '../../../api/scheduler/models/available-crew-response';
import { CopyMasterScheduleRequest } from '../../../api/scheduler/models/copy-master-schedule-request';
import { CopyMasterScheduleResponse } from '../../../api/scheduler/models/copy-master-schedule-response';
import { DeleteSelectedMasterScheduleAllocationsRequest } from '../../../api/scheduler/models/delete-selected-master-schedule-allocations-request';
import { GetMasterScheduleAllocationsResponse } from '../../../api/scheduler/models/get-master-schedule-allocations-response';
import { MasterScheduleAllocationDetailResponse } from '../../../api/scheduler/models/master-schedule-allocation-detail-response';
import { MasterScheduleCalendarResponse } from '../../../api/scheduler/models/master-schedule-calendar-response';
import { MasterScheduleLegendsResponse } from '../../../api/scheduler/models/master-schedule-legends-response';
import { MasterScheduleReferenceDataResponse } from '../../../api/scheduler/models/master-schedule-reference-data-response';
import { SchedulerApiConfiguration } from '../../../api/scheduler/scheduler-api-configuration';

@Injectable({ providedIn: 'root' })
export class SchedulerMasterScheduleApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(SchedulerApiConfiguration);

  getCalendar(dateFrom?: string, dateTo?: string): Observable<MasterScheduleCalendarResponse> {
    return getMasterScheduleCalendar(this.http, this.config.rootUrl, { dateFrom, dateTo }).pipe(
      map((res) => res.body)
    );
  }

  getLegends(): Observable<MasterScheduleLegendsResponse> {
    return getMasterScheduleLegends(this.http, this.config.rootUrl).pipe(map((res) => res.body));
  }

  getReferenceData(): Observable<MasterScheduleReferenceDataResponse> {
    return getMasterScheduleReferenceData(this.http, this.config.rootUrl).pipe(
      map((res) => res.body)
    );
  }

  listAvailableCrew(params: ListAvailableCrew$Params): Observable<AvailableCrewResponse> {
    return listAvailableCrew(this.http, this.config.rootUrl, params).pipe(map((res) => res.body));
  }

  assignAllocations(
    body: AssignMasterScheduleAllocationRequest
  ): Observable<GetMasterScheduleAllocationsResponse> {
    return assignMasterScheduleAllocations(this.http, this.config.rootUrl, { body }).pipe(
      map((res) => res.body)
    );
  }

  replaceAllocations(
    body: AssignMasterScheduleAllocationRequest
  ): Observable<GetMasterScheduleAllocationsResponse> {
    return replaceMasterScheduleAllocations(this.http, this.config.rootUrl, { body }).pipe(
      map((res) => res.body)
    );
  }

  getAllocation(id: number): Observable<MasterScheduleAllocationDetailResponse> {
    return getMasterScheduleAllocation(this.http, this.config.rootUrl, { id }).pipe(
      map((res) => res.body)
    );
  }

  deleteSelectedAllocations(
    body: DeleteSelectedMasterScheduleAllocationsRequest
  ): Observable<BaseResponse> {
    return deleteSelectedMasterScheduleAllocations(this.http, this.config.rootUrl, { body }).pipe(
      map((res) => res.body)
    );
  }

  copySchedule(body: CopyMasterScheduleRequest): Observable<CopyMasterScheduleResponse> {
    return copyMasterSchedule(this.http, this.config.rootUrl, { body }).pipe(
      map((res) => res.body)
    );
  }
}
